import { AvatarScratch as AvatarScratch_phosphor } from './AvatarScratch.phosphor';
import { AvatarScratch as AvatarScratch_zoomg } from './AvatarScratch.zoomg';
import { AvatarScratch as AvatarScratch_zoomit } from './AvatarScratch.zoomit';

const IconRenderer = () => {
  switch (process.env.NEXT_PUBLIC_ICON_SYSTEM) {
    case 'zoomg':
      return AvatarScratch_zoomg;

    case 'phosphor':
      return AvatarScratch_phosphor;

    default:
      return AvatarScratch_zoomit;
  }
};

export const AvatarScratch = IconRenderer();
